// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3nOO9","info":"PatientInfo_info__2QmQm"};